import { render, staticRenderFns } from "./CertificateChangeActivationType.vue?vue&type=template&id=244abf9d&"
import script from "./CertificateChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./CertificateChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports